// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__v9FKw","titleSection":"header_titleSection__J90Ki","selectSection":"header_selectSection__1R6Q3"};